import { Button, EquipUITheme } from '@equip.health/ui';

const { label } = EquipUITheme.typography;

const TOP_LEVEL_ID = 'dialog-action';

const actionButtonStyles = {
  ...label,
  minWidth: '120px',
  padding: '14px 16px',
  size: '56px',
};

type DialogActionButtonProps = {
  handleClick: () => void;
  text: string;
  variant: 'ghost' | 'solid';
  isDisabled?: boolean;
  isLoading?: boolean;
};

/**
 * @deprecated This is only used by WarningModal. Will be removed with GX-3704.
 */
const DialogActionButton = ({
  handleClick,
  isDisabled,
  isLoading,
  text,
  variant,
}: DialogActionButtonProps) => {
  if (variant === 'ghost') {
    return (
      <Button
        {...actionButtonStyles}
        colorScheme="gray"
        id={`${TOP_LEVEL_ID}__${text}`}
        margin="0 16px 0 0"
        onClick={handleClick}
        variant="ghost"
      >
        {text}
      </Button>
    );
  }

  if (variant === 'solid') {
    return (
      <Button
        {...actionButtonStyles}
        colorScheme="red"
        id={`${TOP_LEVEL_ID}__${text}`}
        isDisabled={isDisabled}
        isLoading={isLoading}
        onClick={handleClick}
        primary
        primaryError
        variant="solid"
      >
        {text}
      </Button>
    );
  }

  return null;
};

export default DialogActionButton;
